import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  TextField,
  Card,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  CardHeader,
  CardContent,
  Typography,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
// import { updateUserAccount, getUserById } from "../API/UsersApi";
import { InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Prefixes } from "../Utility/Constants";
import { useTheme } from "@mui/material/styles";
import { PhotoCamera, Delete } from "@mui/icons-material";
import AuthContext from "../Context/AuthProvider";
import { Checkbox, ListItemText } from "@mui/material";
import { UserRoles } from "../Utility/Constants";
// import { useSnackbar } from "../Utility/UserMessageContext";
import { getDisplayValue } from "../Utility/Utility";
import SimpleTextField from "../CustomComponents/ChpTextField";

function EditUser({ userId, onUserUpdated }) {
  const [userDetails, setUserDetails] = useState({
    salutation: "",
    emailId: "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    designation: "",
    suffix: "",
    professionalId: "",
    mobileNo: "",
    roles: [],
    photo: "",
  });
  const theme = useTheme();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Changed to false to skip loading state
  const [changePassword, setChangePassword] = useState(false);
  const [oldPasswordVerified, setOldPasswordVerified] = useState(false);
  const { auth } = useContext(AuthContext);
  // const { showSnackbar } = useSnackbar();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  // Fetch user data on component mount
  useEffect(() => {
    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  const fetchUserData = async () => {
    // Disabled API loading logic
    /*
    setIsLoading(true);
    try {
      const result = await getUserById(auth, userId);
      if (result.isSuccess) {
        const userData = result.data;
        setUserDetails({
          ...userData,
          oldPassword: "",
          password: "",
          confirmPassword: "",
        });
      } else {
        showSnackbar("Failed to load user data", "error");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      showSnackbar("Error loading user data", "error");
    } finally {
      setIsLoading(false);
    }
    */
  };

  function getStyles(option, selectedOptions, theme) {
    return {
      fontWeight: selectedOptions.includes(option)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNo") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setUserDetails((prev) => ({
        ...prev,
        [name]: digitsOnly,
      }));
      return;
    }

    if (name === "suffix" || name === "firstName" || name === "lastName") {
      const validatedValue = value.replace(/[^a-zA-Z_-\s]/g, "").slice(0, 100);
      setUserDetails((prev) => ({
        ...prev,
        [name]: validatedValue,
      }));
      return;
    }

    setUserDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    setUserDetails((prev) => {
      const updatedDetails = {
        ...prev,
        [name]: value,
      };

      if (
        (name === "password" && updatedDetails.confirmPassword) ||
        (name === "confirmPassword" && updatedDetails.password)
      ) {
        setPasswordMismatch(
          updatedDetails.password !== updatedDetails.confirmPassword
        );
      }

      return updatedDetails;
    });
  };

  const handleRolesChange = (event) => {
    const { value } = event.target;
    setUserDetails((prev) => ({
      ...prev,
      roles: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const validatePasswordStrength = (password) => {
    if (!password || password.length < 12) {
      return "Password must be at least 12 characters long";
    }

    let characterTypesCount = 0;
    if (/[A-Z]/.test(password)) characterTypesCount++;
    if (/[a-z]/.test(password)) characterTypesCount++;
    if (/[0-9]/.test(password)) characterTypesCount++;
    if (/[^A-Za-z0-9]/.test(password)) characterTypesCount++;

    if (characterTypesCount < 4) {
      return "Password must include all of: uppercase letters, lowercase letters, numbers, and special characters";
    }

    return null;
  };

  const validateForm = () => {
    const emptyFields = [];
    const requiredFields = [
      "firstName",
      "lastName",
      "emailId",
      "mobileNo",
    ];

    if (changePassword) {
      if (!oldPasswordVerified) {
        alert("Please verify your old password first");
        return false;
      }
      requiredFields.push("password", "confirmPassword");
    }

    requiredFields.forEach((field) => {
      if (!userDetails[field]) emptyFields.push(field);
    });

    if (userDetails.roles.length === 0) emptyFields.push("roles");

    if (emptyFields.length === requiredFields.length + 1) {
      alert("All mandatory fields are required");
      return false;
    }

    if (!userDetails.firstName) {
      alert("First name is required");
      return false;
    }

    if (!userDetails.lastName) {
      alert("Last name is required");
      return false;
    }

    if (!userDetails.emailId) {
      alert("Email is required");
      return false;
    }

    if (userDetails.emailId && !/\S+@\S+\.\S+/.test(userDetails.emailId)) {
      alert("Email address is invalid");
      return false;
    }

    if (changePassword) {
      if (!userDetails.password) {
        alert("New password is required");
        return false;
      }

      if (!userDetails.confirmPassword) {
        alert("Confirm password is required");
        return false;
      }

      const passwordError = validatePasswordStrength(userDetails.password);
      if (passwordError) {
        alert(passwordError);
        return false;
      }

      if (userDetails.password !== userDetails.confirmPassword) {
        setPasswordMismatch(true);
        alert("Passwords do not match");
        return false;
      }
    }

    if (userDetails.roles.length === 0) {
      alert("At least one role is required");
      return false;
    }

    if (!userDetails.mobileNo) {
      alert("Mobile number is required");
      return false;
    }

    if (userDetails.mobileNo.length !== 10) {
      alert("Mobile number must be exactly 10 digits");
      return false;
    }

    return true;
  };

  const verifyOldPassword = () => {
    // In a real implementation, this would call an API to verify the password
    // For now, we'll mock this with a simple check
    if (!userDetails.oldPassword) {
      alert("Please enter your current password");
      return;
    }
    
    // Mock password verification (in real app, would be an API call)
    if (userDetails.oldPassword.length > 3) {
      setOldPasswordVerified(true);
      alert("Password verified successfully");
    } else {
      alert("Incorrect password. Please try again.");
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const userToUpdate = { ...userDetails };
      
      if (!changePassword) {
        delete userToUpdate.oldPassword;
        delete userToUpdate.password;
      }
      
      delete userToUpdate.confirmPassword;

      // Commented out API call
      alert("UI working without API calls");
      /* 
      const result = await updateUserAccount(auth, userId, userToUpdate);
      if (result.isSuccess) {
        showSnackbar("User updated successfully", "success");
        if (onUserUpdated) {
          onUserUpdated();
        }
      } else {
        const errorMessage =
          result.data?.message ||
          result.message ||
          JSON.stringify(result.data) ||
          JSON.stringify(result);
        console.log("Error response:", errorMessage);
        if (
          errorMessage.toLowerCase().includes("email") ||
          errorMessage.toLowerCase().includes("duplicate") ||
          errorMessage.toLowerCase().includes("already exists") ||
          errorMessage.toLowerCase().includes("already in use")
        ) {
          showSnackbar("Email address already exists", "error");
        } else {
          showSnackbar(
            "Update failed: " +
              (result.data?.message || "Unknown error occurred"),
            "error"
          );
        }
      }
      */
      
      if (onUserUpdated) {
        onUserUpdated();
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Update process completed without API calls");
      /*
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        JSON.stringify(error?.response?.data) ||
        JSON.stringify(error);
      console.log("Caught error:", errorMessage);
      if (
        typeof errorMessage === "string" &&
        (errorMessage.toLowerCase().includes("email") ||
          errorMessage.toLowerCase().includes("duplicate") ||
          errorMessage.toLowerCase().includes("already exists") ||
          errorMessage.toLowerCase().includes("already in use"))
      ) {
        showSnackbar("Email address already exists", "error");
      } else {
        showSnackbar("Failed to update user. Please try again.", "error");
      }
      */
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClickShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handlePhotoUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileSizeLimit = 1 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, PNG, and GIF files are allowed.");
      return;
    }

    if (file.size > fileSizeLimit) {
      alert("File size must be less than 1MB.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setUserDetails((prev) => ({
        ...prev,
        photo: e.target.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const handlePhotoDelete = () => {
    setUserDetails((prev) => ({
      ...prev,
      photo: "",
    }));
  };

  const toggleChangePassword = () => {
    setChangePassword(!changePassword);
    setOldPasswordVerified(false);
    if (!changePassword) {
      setUserDetails(prev => ({
        ...prev,
        oldPassword: "",
        password: "",
        confirmPassword: ""
      }));
    }
  };

  if (isLoading) {
    return <Typography>Loading user data...</Typography>;
  }

  return (
    <Grid2 container size={12} spacing={1}>
      <Grid2
        container
        size={12}
        spacing={1}
        sx={{ marginTop: "10px", ml: "5px" }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={isSubmitting}
          sx={{ mr: 2 }}
        >
          {isSubmitting ? "Saving..." : "Update User"}
        </Button>
      </Grid2>
      <Grid2
        container
        size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
        spacing={1}
        sx={{ ml: "5px" }}
      >
        <Card
          variant="outlined"
          sx={{ padding: "5px", marginTop: "5px", width: "100%" }}
        >
          <Grid2 container size={12} spacing={3}>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <FormControl
                fullWidth
                size="small"
                error={isSubmitted && !userDetails.salutation}
                sx={{
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                }}
              >
                <InputLabel id="salutation-label">Prefix</InputLabel>
                <Select
                  labelId="salutation-label"
                  name="salutation"
                  value={userDetails.salutation || ""}
                  onChange={handleChange}
                  input={<OutlinedInput label="Prefix" />}
                  MenuProps={MenuProps}
                >
                  {Prefixes.map((option) => (
                    <MenuItem
                      key={option}
                      value={option}
                      style={getStyles(option, [userDetails.salutation], theme)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Suffix"
                variant="outlined"
                fullWidth
                size="small"
                name="suffix"
                value={userDetails.suffix}
                onChange={handleChange}
                helperText={"Allowed: A-Z, 0-9, _, -. Max 100 chars."}
                FormHelperTextProps={{
                  sx: {
                    fontSize: "0.7rem",
                  },
                }}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <SimpleTextField
                label="First Name"
                name="firstName"
                value={userDetails.firstName}
                onChange={handleChange}
                error={isSubmitted && !userDetails.firstName}
                required={true}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <SimpleTextField
                label="Last Name"
                name="lastName"
                value={userDetails.lastName}
                onChange={handleChange}
                error={isSubmitted && !userDetails.lastName}
                required={true}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Email ID"
                variant="outlined"
                fullWidth
                size="small"
                name="emailId"
                value={userDetails.emailId}
                onChange={handleChange}
                error={isSubmitted && !userDetails.emailId}
                required
                sx={{
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                }}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                fullWidth
                size="small"
                name="mobileNo"
                value={userDetails.mobileNo}
                onChange={handleChange}
                error={isSubmitted && !userDetails.mobileNo}
                required
                sx={{
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                }}
                helperText="Allowed: 0-9. Max 10 digits."
                FormHelperTextProps={{
                  sx: {
                    fontSize: "0.7rem",
                  },
                }}
              />
            </Grid2>

            {/* <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={toggleChangePassword}
                sx={{ mb: 2 }}
              >
                {changePassword ? "Cancel Password Change" : "Change Password"}
              </Button>
            </Grid2>

            {changePassword && (
              <>
                <Grid2 size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
                  <TextField
                    label="Current Password"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="oldPassword"
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    type={showOldPassword ? "text" : "password"}
                    value={userDetails.oldPassword}
                    onChange={handleChange}
                    disabled={oldPasswordVerified}
                    error={isSubmitted && changePassword && !userDetails.oldPassword}
                    required={changePassword}
                    sx={{
                      "& .MuiFormLabel-asterisk": {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle old password visibility"
                            onClick={handleClickShowOldPassword}
                            edge="end"
                            disabled={oldPasswordVerified}
                          >
                            {showOldPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={verifyOldPassword}
                    disabled={oldPasswordVerified || !userDetails.oldPassword}
                    sx={{ height: "40px" }}
                  >
                    Verify Password
                  </Button>
                </Grid2>

                {oldPasswordVerified && (
                  <>
                    <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <TextField
                        label="New Password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="password"
                        onPaste={(e) => e.preventDefault()}
                        onCopy={(e) => e.preventDefault()}
                        type={showPassword ? "text" : "password"}
                        value={userDetails.password}
                        onChange={handlePasswordChange}
                        error={
                          isSubmitted && changePassword && (!userDetails.password || passwordMismatch)
                        }
                        required={changePassword}
                        helperText={
                          passwordMismatch &&
                          userDetails.password &&
                          userDetails.confirmPassword
                            ? "Passwords do not match"
                            : "Password must have 12+ chars, incl. A-Z, a-z, 0-9, symbol"
                        }
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "0.7rem",
                            color: passwordMismatch ? "error.main" : "text.secondary",
                          },
                        }}
                        sx={{
                          "& .MuiFormLabel-asterisk": {
                            color: "red",
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <TextField
                        label="Confirm New Password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        value={userDetails.confirmPassword}
                        onChange={handlePasswordChange}
                        onPaste={(e) => e.preventDefault()}
                        onCopy={(e) => e.preventDefault()}
                        error={
                          isSubmitted &&
                          changePassword &&
                          (!userDetails.confirmPassword || passwordMismatch)
                        }
                        required={changePassword}
                        helperText={
                          passwordMismatch &&
                          userDetails.password &&
                          userDetails.confirmPassword
                            ? "Passwords do not match"
                            : ""
                        }
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "0.7rem",
                            color: "error.main",
                          },
                        }}
                        sx={{
                          "& .MuiFormLabel-asterisk": {
                            color: "red",
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle confirm password visibility"
                                onClick={handleClickShowConfirmPassword}
                                edge="end"
                              >
                                {showConfirmPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid2>
                  </>
                )}
              </>
            )} */}

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <FormControl
                fullWidth
                size="small"
                error={isSubmitted && userDetails.roles.length === 0}
                required
                sx={{
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                }}
              >
                <InputLabel id="roles-label">Roles</InputLabel>
                <Select
                  labelId="roles-label"
                  multiple
                  name="roles"
                  value={userDetails.roles}
                  onChange={handleRolesChange}
                  input={<OutlinedInput label="Roles" />}
                  renderValue={(selected) =>
                    selected.map(getDisplayValue).join(", ")
                  }
                  MenuProps={MenuProps}
                  required
                >
                  {UserRoles.map((role) => (
                    <MenuItem
                      key={role}
                      value={role}
                      style={getStyles(role, userDetails.roles, theme)}
                    >
                      <Checkbox
                        checked={userDetails.roles.indexOf(role) > -1}
                      />
                      <ListItemText primary={getDisplayValue(role)} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Designation"
                variant="outlined"
                fullWidth
                size="small"
                name="designation"
                value={userDetails.designation}
                onChange={handleChange}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Professional ID"
                variant="outlined"
                fullWidth
                size="small"
                name="professionalId"
                value={userDetails.professionalId}
                onChange={handleChange}
              />
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2
        size={{ xs: 6, sm: 6, md: 6, lg: 2, xl: 2 }}
        sx={{ mt: "3px" }}
        container
        alignItems="flex-start"
        justifyContent="flex-start"
        direction="column"
      >
        <Card variant="outlined" sx={{ padding: "10px", width: "100%" }}>
          <CardHeader subheader="User Image" sx={{ paddingX: 0 }} />
          <CardContent>
            <Grid2
              container
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Grid2 size={12} container justifyContent="center">
                <img
                  src={
                    userDetails.photo || "./placeholder-image-male-gender.webp"
                  }
                  alt="User Photo"
                  width="120"
                  height="120"
                  className="border rounded p-0"
                />
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ padding: 0 }}
                >
                  Upload image size max 1MB
                </Typography>
              </Grid2>

              <input
                type="file"
                accept="image/jpeg, image/png, image/gif"
                hidden
                id="photo-upload"
                onChange={handlePhotoUpload}
              />

              <Grid2
                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <Grid2>
                  <label htmlFor="photo-upload">
                    <IconButton component="span">
                      <PhotoCamera />
                    </IconButton>
                  </label>
                </Grid2>

                {userDetails.photo && (
                  <Grid2>
                    <IconButton onClick={handlePhotoDelete}>
                      <Delete />
                    </IconButton>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>
          </CardContent>
        </Card>
      </Grid2>
    </Grid2>
  );
}

export default EditUser;